import { Link } from 'react-router-dom';

const packages = [
  {
    id: 'pkg-1',
    title: '海岛蜜月奢享',
    description: '5天4晚马尔代夫水上别墅 + 双人SPA + 私人海滩晚宴',
    price: '29,999',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20overwater%20villa%20in%20Maldives%20with%20private%20pool%20and%20glass%20floor%2C%20turquoise%20lagoon%2C%20couple%20enjoying%20sunset%20on%20deck%2C%20romantic%20dinner%20setup%20on%20beach%2C%20paradise%20atmosphere%2C%20warm%20golden%20light&width=800&height=500&seq=pkg-maldives&orientation=landscape',
    link: '/category/honeymoon',
  },
  {
    id: 'pkg-2',
    title: '古城慢旅时光',
    description: '3天2晚丽江束河古镇 + 雪山观景民宿 + 手工扎染体验',
    price: '5,999',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20town%20Lijiang%20Yunnan%20with%20traditional%20Naxi%20architecture%20and%20cobblestone%20streets%2C%20Jade%20Dragon%20Snow%20Mountain%20in%20background%2C%20romantic%20courtyard%20with%20lanterns%2C%20warm%20cozy%20atmosphere&width=800&height=500&seq=pkg-lijiang&orientation=landscape',
    link: '/category/romantic-packages',
  },
  {
    id: 'pkg-3',
    title: '都市浪漫夜宴',
    description: '外滩江景套房一晚 + 米其林双人晚餐 + 屋顶酒吧鸡尾酒',
    price: '8,888',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20hotel%20suite%20with%20floor%20to%20ceiling%20windows%20overlooking%20Shanghai%20skyline%20at%20night%2C%20romantic%20dinner%20table%20by%20window%2C%20city%20lights%2C%20elegant%20modern%20interior&width=800&height=500&seq=pkg-shanghai&orientation=landscape',
    link: '/category/romantic-packages',
  },
];

export default function RomanticPackages() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading font-semibold text-foreground-900">
            精选浪漫套餐
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            一站式打包浪漫体验，省心省力，只负责享受二人世界
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {packages.map((pkg) => (
            <article key={pkg.id} className="bg-background-100 rounded-lg overflow-hidden group cursor-pointer">
              <div className="relative h-48 md:h-56 overflow-hidden">
                <img
                  src={pkg.image}
                  alt={pkg.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-5 md:p-6">
                <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-2">{pkg.title}</h3>
                <p className="text-foreground-500 text-sm leading-relaxed mb-4">{pkg.description}</p>
                <div className="flex items-center justify-between">
                  <div>
                    <span className="text-xs text-foreground-400">起</span>
                    <span className="text-xl font-heading font-semibold text-primary-500 ml-1">¥{pkg.price}</span>
                    <span className="text-xs text-foreground-400">/双人</span>
                  </div>
                  <Link
                    to={pkg.link}
                    className="px-4 py-2 bg-primary-500 text-background-50 dark:text-foreground-950 text-sm font-medium rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    了解详情
                  </Link>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}